angular.module('dpw.services').provider('paging', function () {
        var perPage = 10;
        this.setPerPage = function (maxRecords) {
            perPage = maxRecords;
        };
        this.$get = function () {
            return {
                init: function (scope, callback, ns, context, contextPath) {
                    ns = ns || 'paging';
                    context = context || scope;
                    contextPath = contextPath ? (contextPath + '.') : '';
                    if (!context[ns]) {
                        context[ns] = {
                            page: 1,
                            pageEnd: 0,
                            pageStart: 0,
                            perPage: perPage,
                            totalElements: 0,
                            totalPages: 0
                        };
                    }
                    var targetString = contextPath + ns + '.page';
                    scope.$watch(targetString, function (newValue, oldValue) {
                        (newValue != oldValue) && (newValue != 0) && callback();
                        newValue == 0 && (context[ns].page = 1);
                    });
                    return {
                        newSearch: function () {
                            var originalPage = context[ns].page;
                            context[ns].page = 1;
                            //need to invoke callback manually because watch won't catch
                            (originalPage == context[ns].page) && callback();
                        },
                        getPaging: function () {
                            return context[ns];
                        },
                        reset: function (data) {
                            context[ns] = data.paging;
                        },
                        setPerPage: function (perPage) {
                            context[ns].perPage = perPage;
                        }
                    };
                }
            };
        };
    }
);
